
import { defineComponent } from 'vue'
import AsahiTypography from '@/components/library/Typography.vue'
import AsahiButton from './library/AsahiButton.vue'
import refreshAfterChangeLanguage from '@/mixins/refreshAfterChangeLanguage'
import AsahiInput from './library/AsahiInput.vue'
import 'vue3-carousel/dist/carousel.css'
import checkRingSvgIcon from '@/assets/icons/check_ring.svg'
import minusCircleSvgIcon from '@/assets/icons/minus-circle.svg'
import addSquareSvgIcon from '@/assets/icons/add-square.svg'
import MazPhoneNumberInput from 'maz-ui/components/MazPhoneNumberInput'
import { UserActionType } from '@/store/modules/users/interfaces/action-type'
import InfoIcon from './library/icons/InfoIcon.vue'
import LoaderSpinner from './common/LoaderSpinner.vue'
import RoleDescription from './profile/RoleDescription.vue'
import { magnoliaServiceAPI } from '@/store/api-instance'
import EditIcon from '@/components/library/icons/EditIcon.vue'
import { RolePermissionDetails } from '@/store/modules/users/interfaces/IUser'
import AsahiSelectBox from './library/AsahiSelectBox.vue'
import { setNewConsentsModal } from '@/store/modules/auth/services/auth.api'

export default defineComponent({
  name: 'ConsentModal',

  components: {
    AsahiTypography,
    AsahiButton,
    AsahiInput,
    MazPhoneNumberInput,
    InfoIcon,
    LoaderSpinner,
    RoleDescription,
    EditIcon,
    AsahiSelectBox
  },

  mixins: [refreshAfterChangeLanguage],

  data () {
    return {
      checkRingSvgIcon,
      minusCircleSvgIcon,
      addSquareSvgIcon,
      disableProceed: true,
      termsAndConditionAccepted: false,
      privacyPolicyAccepted: false,
      isValidPhone: false,
      hideModal: false,
      newPhoneNumber: '',
      isLoading: false,
      editNumber: false,
      isFirstTouachPhoneInput: true,
      roles: [] as string[],
      permissions: [] as {label: string, values:(boolean | null)[]}[],
      recommendedSettings: {
        roleMatrix: [
          {
            customerType: 'POS',
            matrix: {
              roles: [
                'Key User',
                'Delegated owner',
                'Associate',
                'Shift leader',
                'Accountant',
                'Common user'
              ],

              permissions: [
                {
                  label: 'Essential account and business updates',
                  values: [true, true, false, false, false, false]
                },
                {
                  label: 'Order and billing information',
                  values: [true, true, true, false, true, false]
                },
                {
                  label: 'Product and service updates',
                  values: [true, true, true, true, false, false]
                },
                {
                  label: 'Personalized offers and trainings',
                  values: [true, true, true, true, true, true]
                }
              ]

            }
          },
          {
            customerType: 'WHSL',
            matrix: {
              roles: [
                'Key User',
                'Delegated owner',
                'Warehouse Manager',
                'Accountant',
                'Common user'
              ],

              permissions: [
                {
                  label: 'Essential account and business updates',
                  values: [true, true, false, false, false]
                },
                {
                  label: 'Order and billing information',
                  values: [true, true, true, true, false]
                },
                {
                  label: 'Product and service updates',
                  values: [true, true, true, false, true]
                },
                {
                  label: 'Personalized offers and trainings',
                  values: [true, true, true, true, true]
                }
              ]

            }
          }
        ]
      },
      isActiveLanguageSK: false,
      consentsData: [],
      selectedGender: null as string | null,
      isGenderSelected: true
    }
  },

  computed: {
    user () {
      return this.$store.state.auth.user
    },
    genderList () {
      return [
        { label: this.$t('Mrs.'), value: 'f' },
        { label: this.$t('Mr.'), value: 'm' },
        { label: this.$t('Do not wish to specify'), value: 'u' }

      ]
    },
    isKeyUser () {
      return this.user.isKeyAccount
    },
    isProceedDisabled () {
      return this.disableProceed || !this.selectedGender
    },
    customerType (): RolePermissionDetails | undefined {
      if (this.user && this.user?.permissionSchema?.length > 0) {
        return this.user?.permissionSchema[0]?.rpDetails?.find((item: RolePermissionDetails) => item.customerType)
      }
      return undefined
    },

    isLoggedIn () {
      return this.user.isLoggedIn
    },

    countryCode () {
      if (this.$store.state.auth.user.country === 'SVK') {
        return 'SK'
      } else {
        return 'CZ'
      }
    }
  },

  props: {
    closeModal: {
      type: Function,
      default: () => {
        /* */
      }
    }
  },
  async created () {
    await this.getValidationPageContent()
  },

  mounted () {
    this.getRoleMatrix()
  },

  methods: {
    close () {
      this.closeModal()
    },
    handleGenderSelection (value: string) {
      this.selectedGender = value
    },
    getRoleMatrix () {
      const customerType = localStorage.getItem('customertype') || this.user.permissionSchema?.[0].rpDetails[0].customerType
      const currentMatrix = this.recommendedSettings.roleMatrix.find((item:any) => {
        return item.customerType === customerType
      })
      if (currentMatrix) {
        this.roles = currentMatrix?.matrix.roles
        this.permissions = currentMatrix?.matrix.permissions
      }
    },
    async getValidationPageContent () {
      this.isLoading = true
      try {
        const isUserValidation = this.$route.meta?.isUserVerification
        const response = await magnoliaServiceAPI.get('/uservalidation')
        const filterParam = isUserValidation ? 'UserValidationpage' : 'PopUp'
        const filteredContent = response.data.results?.find((item: any) => {
          return item.tag === filterParam
        })
        this.consentsData = filteredContent.userValidationPageContents
      } catch {
        this.isLoading = false
      }
      this.isLoading = false
    },
    changeNumber () {
      this.user.phone = ''
    },
    checkPhoneNumber (event: any) {
      this.isValidPhone = event.isValid
      this.isActiveLanguageSK = event?.countryCode === 'SK'
      if (event?.countryCode === 'SK' && event?.nationalNumber?.length !== 9) {
        this.isValidPhone = false
      }
      if (event?.nationalNumber) {
        this.isFirstTouachPhoneInput = false
      }
      this.newPhoneNumber = event.e164
      if (this.isKeyUser) {
        if (this.termsAndConditionAccepted && this.isValidPhone) {
          this.disableProceed = false
        } else {
          this.disableProceed = true
        }
      } else {
        if (this.termsAndConditionAccepted && ((this.editNumber && this.isValidPhone) || (!this.editNumber && (!this.newPhoneNumber || this.isValidPhone)))) {
          this.disableProceed = false
        } else {
          this.disableProceed = true
        }
      }
    },
    toggleEditMode () {
      this.editNumber = !this.editNumber
      if (!this.isKeyUser) {
        if (this.termsAndConditionAccepted && ((this.editNumber && this.isValidPhone) || (!this.editNumber && this.user.phone && this.user.phone !== ''))) {
          this.disableProceed = false
        } else {
          this.disableProceed = true
        }
      } else {
        if (this.termsAndConditionAccepted && (this.user.phone && this.user.phone !== '' && !this.editNumber)) {
          this.disableProceed = false
        } else {
          this.disableProceed = true
        }
      }
    },
    setAcceptedCheckbox (event: any) {
      if (event.target.id === 'termsAndCondition') {
        this.termsAndConditionAccepted = event.target.checked
        if (!this.isKeyUser && (!this.newPhoneNumber || (this.newPhoneNumber && this.isValidPhone))) {
          this.isValidPhone = true
        }
        if (this.isKeyUser) {
          if (this.termsAndConditionAccepted && (this.isValidPhone || (this.user.phone && this.user.phone !== '' && !this.editNumber))) {
            this.disableProceed = false
          } else {
            this.disableProceed = true
          }
        } else {
          if (this.termsAndConditionAccepted && ((this.isValidPhone && !this.editNumber) || (this.editNumber && this.isValidPhone))) {
            this.disableProceed = false
          } else {
            this.disableProceed = true
          }
        }
      }
      if (event.target.id === 'privacyPolicy') {
        this.privacyPolicyAccepted = event.target.checked
      }
    },
    checkGenderSelection () {
      this.isGenderSelected = !!this.selectedGender
    },
    async submit () {
      if (!this.user.gender) { this.checkGenderSelection() }

      if (this.isGenderSelected || this.user.gender) {
        const updatedUser = {
          id: this.user.UID
        } as any

        if (this.user.phone !== this.newPhoneNumber && this.newPhoneNumber && this.isValidPhone) {
          updatedUser.phone = this.newPhoneNumber
        } if (this.selectedGender) {
          updatedUser.gender = this.selectedGender
        }
        if ((this.newPhoneNumber && this.isValidPhone) || this.selectedGender) {
          await this.$store.dispatch(`users/${UserActionType.UPDATE_USER}`, updatedUser, { root: true })
        }

        if (this.isKeyUser && !this.privacyPolicyAccepted) {
          this.hideModal = true
        } else {
          this.proceed()
        }
      }
    },
    goBack () {
      this.hideModal = false
    },
    async proceed () {
      this.hideModal = false
      this.isLoading = true
      const response = await setNewConsentsModal(
        {
          isTermsConditionAccepted: this.termsAndConditionAccepted,
          isMarketingCommunicationAccepted: this.privacyPolicyAccepted
        }
      )
      if (response) {
        this.isLoading = false
        this.closeModal()
      } else {
        this.isLoading = false
      }
    }
  }
})

